import { parseTemplate } from 'url-template';
import { Export } from '~/Api/User/ProductGroup/Export';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import ErrorResponse from './ErrorResponse';

export interface Result {
	readonly export: Export;
}

export default async function createExportXls(client: ApiClient, userId: string, groupId: string): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/ae-max-price/export-pdf');

	try {
		const request = await client.fetch(url.expand({ userId, groupId }), {
			method: 'POST',
		});
		return await request.json();
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new ErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
}
